import { URL_BASE } from "../../../../../Globals.ts";

export const getCodeReview = async (files: string[], changesMade: string, task: string): Promise<string | null> => {
    try {
        const url = `${URL_BASE}/api/getCodeReview`;

        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                files: files,
                changesMade: changesMade,
                task: task
            })
        });

        if (response.ok) {
            const responseData = await response.json();
            return responseData.codeReview;
        } else {
            console.error(`Failed to get code review: ${response.statusText}`);
            return "";
        }
    } catch (error) {
        console.error(`Error getting code review: ${error}`);
        return "";
    }
};